import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderComponent } from '../../ui-elements/loader/loader.component';
import { PermissionsService } from '../services/permissions/permissions.service';

@Component({
  selector: 'app-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['./impersonate.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LoaderComponent],
})
export class ImpersonateComponent implements OnInit {
  private router = inject(Router);
  private permissionsService = inject(PermissionsService);

  ngOnInit() {
    this.permissionsService.getPermissions().subscribe(() => {
      this.router.navigate(['/']);
    });
  }
}
